import { render } from "./SuperAdminGeneral.vue?vue&type=template&id=1ea673bd"
import script from "./SuperAdminGeneral.vue?vue&type=script&lang=js"
export * from "./SuperAdminGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__